import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import {User} from '../../../model/user/user.model';
import {DialogService} from '../../../services/dialog.service';

@Component({
    selector: 'app-dialog-select-young-inscription-family',
    templateUrl: './dialog-select-young-inscription-family.component.html',
    styleUrls: ['./dialog-select-young-inscription-family.component.scss'],
    imports: [MatDialogTitle]
})
export class DialogSelectYoungInscriptionFamilyComponent implements OnInit, OnDestroy {
    dialogRef = inject<MatDialogRef<DialogSelectYoungInscriptionFamilyComponent>>(MatDialogRef);
    data = inject<{
    families: unknown;
}>(MAT_DIALOG_DATA);
    private readonly dialogService = inject(DialogService);


    result: {
        tutor1: unknown,
        tutor2: unknown
    };
    currentResult: {
        tutor1: unknown,
        tutor2: unknown
    };
    abort = true;

    @Input() families: User[] = [];

    @Output() radioChange: EventEmitter<unknown>;

    constructor() {
        const dialogRef = this.dialogRef;

        dialogRef.disableClose = true;
    }

    ngOnInit() {
        if (this.data.families && Array.isArray(this.data.families)) {
            this.families = this.data.families;
        }
        if (!this.families || this.families.length === 0) {
            this.dialogRef.close(undefined);
        }
    }

    onRadioChange(event) {
        this.currentResult = {
            tutor1: (event?.family1) ? this.families.find(value => value.id === event.family1) : undefined,
            tutor2: (event?.family2) ? this.families.find(value => value.id === event.family2) : undefined
        };
    }

    async exit(skip = false) {
        if (skip) {
            this.currentResult = undefined;
        }
        this.result = this.currentResult;
        this.abort = false;
        if (this.result && !this.result.tutor1 && this.result.tutor2) {
            this.dialogService.confirm(
                'Tuteur principal non renseignĂ©',
                'Si vous continuer, le tuteur secondaire deviendra le tuteur principal.',
                'Continuer',
                'Annuler').then(value => {
                if (value) {
                    this.result.tutor1 = this.result.tutor2;
                    this.result.tutor2 = undefined;
                    this.dialogRef.close();
                }
            });
        } else {
            this.dialogRef.close();
        }
    }

    abortAction() {
        this.abort = true;
        this.dialogRef.close();
    }

    ngOnDestroy() {
        // Exit without choose young or create new
        if (this.abort) {
            this.dialogRef.close(undefined);
        } else {
            this.dialogRef.close(this.result ? this.result : {});
        }
    }
}
